import { render, staticRenderFns } from "./BadgeWithLink.vue?vue&type=template&id=59723dad&scoped=true&"
import script from "./BadgeWithLink.vue?vue&type=script&lang=js&"
export * from "./BadgeWithLink.vue?vue&type=script&lang=js&"
import style0 from "./BadgeWithLink.vue?vue&type=style&index=0&id=59723dad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59723dad",
  null
  
)

export default component.exports